// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as MenuActions from "../../resources/navigation/MenuActions.res.js";
import * as OrderArchiveModal from "./OrderArchiveModal.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function OrderEditActionsList(props) {
  let onRequestAction = props.onRequestAction;
  let statuses = props.statuses;
  let match = React.useState(() => false);
  let setArchivingModalOpened = match[1];
  let tmp;
  let exit = 0;
  let len = statuses.length;
  if (len >= 3) {
    tmp = null;
  } else {
    switch (len) {
      case 0 :
        tmp = null;
        break;
      case 1 :
        let match$1 = statuses[0];
        if (match$1 === "ARCHIVED") {
          tmp = JsxRuntime.jsx(MenuActions.make, {
            children: JsxRuntime.jsxs(MenuActions.Section.make, {
              children: [
                JsxRuntime.jsx(MenuActions.Item.make, {
                  title: I18n.t("Download PDF"),
                  icon: "pdf_see",
                  onAction: () => onRequestAction("DownloadPDF")
                }),
                JsxRuntime.jsx(MenuActions.Item.make, {
                  title: I18n.t("Download CSV"),
                  icon: "csv_see",
                  onAction: () => onRequestAction("DownloadCSV")
                })
              ]
            }),
            trigger: {
              TAG: "Normal",
              label: I18n.t("Actions")
            }
          });
        } else if (match$1 === "DRAFT") {
          tmp = JsxRuntime.jsxs(MenuActions.make, {
            children: [
              JsxRuntime.jsxs(MenuActions.Section.make, {
                children: [
                  JsxRuntime.jsx(MenuActions.Item.make, {
                    title: I18n.t("Download PDF"),
                    icon: "pdf_see",
                    onAction: () => onRequestAction("DownloadPDF")
                  }),
                  JsxRuntime.jsx(MenuActions.Item.make, {
                    title: I18n.t("Download CSV"),
                    icon: "csv_see",
                    onAction: () => onRequestAction("DownloadCSV")
                  })
                ]
              }),
              JsxRuntime.jsx(MenuActions.Section.make, {
                children: JsxRuntime.jsx(MenuActions.Item.make, {
                  title: I18n.t("Archive"),
                  tone: "danger",
                  icon: "archive",
                  onAction: () => setArchivingModalOpened(param => true)
                })
              })
            ],
            trigger: {
              TAG: "Normal",
              label: I18n.t("Actions")
            }
          });
        } else if (match$1 === "FINALIZED") {
          exit = 1;
        } else {
          tmp = match$1 === "RECEIVING" ? JsxRuntime.jsxs(MenuActions.make, {
              children: [
                JsxRuntime.jsx(MenuActions.Section.make, {
                  children: JsxRuntime.jsx(MenuActions.Item.make, {
                    title: I18n.t("Continue reception"),
                    tone: "brand",
                    icon: "edit",
                    onAction: () => onRequestAction("Edition")
                  })
                }),
                JsxRuntime.jsxs(MenuActions.Section.make, {
                  children: [
                    JsxRuntime.jsx(MenuActions.Item.make, {
                      title: I18n.t("Download PDF"),
                      icon: "pdf_see",
                      onAction: () => onRequestAction("DownloadPDF")
                    }),
                    JsxRuntime.jsx(MenuActions.Item.make, {
                      title: I18n.t("Download CSV"),
                      icon: "csv_see",
                      onAction: () => onRequestAction("DownloadCSV")
                    })
                  ]
                }),
                JsxRuntime.jsx(MenuActions.Section.make, {
                  children: JsxRuntime.jsx(MenuActions.Item.make, {
                    title: I18n.t("Archive"),
                    tone: "danger",
                    icon: "archive",
                    onAction: () => setArchivingModalOpened(param => true)
                  })
                })
              ],
              trigger: {
                TAG: "Normal",
                label: I18n.t("Actions")
              }
            }) : null;
        }
        break;
      case 2 :
        let match$2 = statuses[0];
        if (match$2 === "ACCEPTED") {
          let match$3 = statuses[1];
          if (match$3 === "NOT_RECEIVED") {
            exit = 1;
          } else {
            tmp = null;
          }
        } else if (match$2 === "RECEIVED") {
          let match$4 = statuses[1];
          tmp = match$4 === "TO_PAY" ? JsxRuntime.jsxs(MenuActions.make, {
              children: [
                JsxRuntime.jsx(MenuActions.Section.make, {
                  children: JsxRuntime.jsx(MenuActions.Item.make, {
                    title: I18n.t("Edit order prices"),
                    tone: "brand",
                    icon: "edit",
                    onAction: () => onRequestAction("Edition")
                  })
                }),
                JsxRuntime.jsxs(MenuActions.Section.make, {
                  children: [
                    JsxRuntime.jsx(MenuActions.Item.make, {
                      title: I18n.t("Download PDF"),
                      icon: "pdf_see",
                      onAction: () => onRequestAction("DownloadPDF")
                    }),
                    JsxRuntime.jsx(MenuActions.Item.make, {
                      title: I18n.t("Download CSV"),
                      icon: "csv_see",
                      onAction: () => onRequestAction("DownloadCSV")
                    })
                  ]
                }),
                JsxRuntime.jsx(MenuActions.Section.make, {
                  children: JsxRuntime.jsx(MenuActions.Item.make, {
                    title: I18n.t("Archive"),
                    tone: "danger",
                    icon: "archive",
                    onAction: () => setArchivingModalOpened(param => true)
                  })
                })
              ],
              trigger: {
                TAG: "Normal",
                label: I18n.t("Actions")
              }
            }) : (
              match$4 === "PAID" ? JsxRuntime.jsxs(MenuActions.make, {
                  children: [
                    JsxRuntime.jsxs(MenuActions.Section.make, {
                      children: [
                        JsxRuntime.jsx(MenuActions.Item.make, {
                          title: I18n.t("Download PDF"),
                          icon: "pdf_see",
                          onAction: () => onRequestAction("DownloadPDF")
                        }),
                        JsxRuntime.jsx(MenuActions.Item.make, {
                          title: I18n.t("Download CSV"),
                          icon: "csv_see",
                          onAction: () => onRequestAction("DownloadCSV")
                        })
                      ]
                    }),
                    JsxRuntime.jsx(MenuActions.Section.make, {
                      children: JsxRuntime.jsx(MenuActions.Item.make, {
                        title: I18n.t("Archive"),
                        tone: "danger",
                        icon: "archive",
                        onAction: () => setArchivingModalOpened(param => true)
                      })
                    })
                  ],
                  trigger: {
                    TAG: "Normal",
                    label: I18n.t("Actions")
                  }
                }) : null
            );
        } else {
          tmp = null;
        }
        break;
    }
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsxs(MenuActions.make, {
      children: [
        JsxRuntime.jsx(MenuActions.Section.make, {
          children: JsxRuntime.jsx(MenuActions.Item.make, {
            title: I18n.t("Edit order"),
            tone: "brand",
            icon: "edit",
            onAction: () => onRequestAction("Edition")
          })
        }),
        JsxRuntime.jsxs(MenuActions.Section.make, {
          children: [
            JsxRuntime.jsx(MenuActions.Item.make, {
              title: I18n.t("Download PDF"),
              icon: "pdf_see",
              onAction: () => onRequestAction("DownloadPDF")
            }),
            JsxRuntime.jsx(MenuActions.Item.make, {
              title: I18n.t("Download CSV"),
              icon: "csv_see",
              onAction: () => onRequestAction("DownloadCSV")
            })
          ]
        }),
        JsxRuntime.jsx(MenuActions.Section.make, {
          children: JsxRuntime.jsx(MenuActions.Item.make, {
            title: I18n.t("Archive"),
            tone: "danger",
            icon: "archive",
            onAction: () => setArchivingModalOpened(param => true)
          })
        })
      ],
      trigger: {
        TAG: "Normal",
        label: I18n.t("Actions")
      }
    });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      tmp,
      JsxRuntime.jsx(OrderArchiveModal.make, {
        orderId: props.id,
        opened: match[0],
        onRequestClose: () => setArchivingModalOpened(param => false)
      })
    ]
  });
}

let make = React.memo(OrderEditActionsList, (oldProps, newProps) => {
  if (oldProps.id === newProps.id) {
    return oldProps.statuses === newProps.statuses;
  } else {
    return false;
  }
});

export {
  make,
}
/* make Not a pure module */
